import { useState, useEffect } from 'react'
import { useVerifyEmailByTokenMutation } from '../../../../../api/integrations'

/**
 * Custom hook to verify domain token
 * @param {string} token
 * @returns {Object}
 */
const useVerifyDomainToken = token => {
  const [status, setStatus] = useState('loading') // loading, success, error
  const [errorMessage, setErrorMessage] = useState('')

  const [verifyEmailByToken, { isLoading }] = useVerifyEmailByTokenMutation()

  const verifyToken = async () => {
    if (!token) {
      setStatus('error')
      setErrorMessage('Verification token is missing')
      return
    }

    try {
      setStatus('loading')
      await verifyEmailByToken({ token }).unwrap()
      setStatus('success')
      return true
    } catch (error) {
      setStatus('error')
      setErrorMessage(error?.data?.message || 'Failed to verify domain. Please try again.')
      return false
    }
  }

  useEffect(() => {
    verifyToken()
  }, [token])

  return {
    status,
    errorMessage,
    isLoading,
    verifyToken
  }
}

export default useVerifyDomainToken
